import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
type CounterProps = {
  value: number;
  prefix?: string;
  suffix?: string;
};
export function Counter({
  value,
  prefix = '',
  suffix = ''
}: CounterProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  const reduceMotion = useReducedMotion();
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    if (!inView) return;
    if (reduceMotion) {
      setDisplay(value);
      return;
    }
    const controls = animate(0, value, {
      duration: 1.6,
      ease: EASE_OUT,
      onUpdate: v => setDisplay(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, value, reduceMotion]);
  return <span ref={ref} className="tabular-nums" data-id="element-397" data-mp="2lb6xxzrn5ed4">
      {prefix}
      {display}
      {suffix}
    </span>;
}